export function setTableSorter(data){
  return (dispatch) => {
    return dispatch({
      type:'SET_TABLE_SORTER',
      payload: data
    })
  }
}
